export const setMarkDone = () => ({
    type: 'SET_MARK_DONE',
});